module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 20.8b9d7bfb.mp3";